import { makeStyles } from "@material-ui/core/styles";
import { renderToStaticMarkup } from "react-dom/server";
const projectDetailsSettingsStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiFormHelperText-root": {
      color: "#ffcc00",
    },
    fontFamily: "Poppins",
  },
  card: {
    borderRadius: "20px",
  },
  cardContent: {
    backgroundColor: theme.palette.primary.main,
    padding: "20px",
  },
  imageContentDiv: {
    width: "200px",
    height: "200px",
    display: "grid",
    borderRadius: "10px",
    overflow: "hidden",
  },
  projectThumbnail: {
    width: "200px",
    height: "200px",
    cursor: "pointer",
    borderRadius: "10px",
    objectFit: "cover",
  },

  inputLabel: {
    color: theme.palette.text.tertiary,
    display: "inline-block",
    marginBottom: "10px",
  },
  cardContentDiv3: {
    width: "100%",
    backgroundColor: theme.palette.secondary.light,
    maxHeight: "30px",
    //padding: "-4px",
    borderRadius: "10px",
  },
  cardContentInput1: {
    padding: "3.5px 18px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    width: "100%",
    height: "40px",
  },
  cardContentDiv4: {
    // margin: "0% 5% 0% 5%",
    marginTop: "8px",
  },
}));

export default projectDetailsSettingsStyles;
